import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';

import cPdtCtgList from './cPdtCtgList';

export default class iPdtCtgList extends cPdtCtgList {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  $id_stgs = { // 子で上書き
    cLoadCnd: () => bf.b([
      {
        b_when: global.c?.state.sgcd_pageCmns?.userc410 == '80',
        o_then: () => {
          let _cnd = bf.q('[cm5tb11k]="{}"'.f(
            global.c?.state.sgcd_pageCmns?.cm20_key,
          ));
          return _cnd;
        }
      },
      {
        o_else: () => {
          let _cnd = bf.q('[cm5tb11k]="{}" AND IFNULL([cm5tcz10],"10")<>"0"'.f(
            global.c?.state.sgcd_pageCmns?.cm20_key,
          ));
          return _cnd;
        }
      }
    ]),
  };

  render() {
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        b_rhtVsb={bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80']) ? true : false}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iPdtCtgDtl',
            sgc_pageMode: 'new',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        n_bdyW={ic.gn_w}
        d_hdrs={{
          pfx: iv._get_hdrPfx('商品分類一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            ld_iss: [
              ip.dd_rptss['商品分類一覧CSV'],
            ],
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_cm5tss',
              nextRole: global.c?.state.sgc_pageRole,
              nextPage: 'iPdtCtgDtl',
              nextMode: 'show',
              keyName: 'cm5t_key',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            }
          ]
        }}
      />
    );
  }

};
